import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Switch from "material-ui-next/Switch";
import { DataTable, Loadable, IconButton } from "components/support";
import { DiscountTypeValues } from "core/enum";
import { colors } from "assets";
import { withStyles } from "material-ui-next/styles";

const Toggle = withStyles({
  bar: {
    backgroundColor: colors.switch.primary,
    opacity: 0.3
  },
  checked: {
    color: colors.switch.primary,
    transform: "translateX(14px)",
    "& + $bar": {
      backgroundColor: colors.switch.primary,
      opacity: 0.5
    }
  }
})(Switch);

class DataTableView extends Component {
  config = {
    identifier: "uuid",
    columns: [
      {
        accessor: "uuid",
        show: false
      },
      {
        id: "description",
        accessor: "description",
        Header: "Descrição"
      },
      {
        id: "type",
        accessor: "type",
        Header: "Tipo",
        align: "center",
        type: "enum",
        params: { enum: DiscountTypeValues },
        sortable: false
      },
      {
        id: "enabled",
        accessor: "enabled",
        Header: "Ativo",
        align: "center",
        sortable: false,
        Cell: props =>
          this.parseSwitchField(props.row._index, props.row._original)
      },
      {
        id: "actions",
        Header: "Ações",
        align: "right",
        sortable: false,
        Cell: props => this.parseActionsField(props.row._original)
      }
    ]
  };

  parseSwitchField = (index, discount) => (
    <Toggle
      checked={discount.enabled}
      onChange={(_, checked) =>
        this.props.presenter.handleChangeSwitch(index, discount, checked)
      }
    />
  );

  parseActionsField = discount => {
    const { presenter } = this.props;

    return (
      <div>
        <IconButton
          mini
          icon="search"
          onClick={() => presenter.onViewDiscount(discount)}
        />
        <IconButton
          mini
          icon="mode_edit"
          onClick={() => presenter.onEditDiscount(discount)}
        />
      </div>
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      nextProps.presenter.onFilterChange(nextProps.filter);
    }
  }

  handleDataTableChange = ({ field, value }) => {
    const { presenter } = this.props;
    presenter.onOrderChange(field, value);
  };

  handlePageChange = page => {
    const { presenter } = this.props;
    presenter.onPageChange(page + 1);
  };

  render() {
    const { loading, result, pagination, order } = this.props.viewModel;

    return (
      <div className="mt-md">
        <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
          {pagination.total} desconto(s) encontrado(s).
        </h3>
        <Paper elevation={1} className="optional__content">
          <Loadable loading={loading}>
            <DataTable
              manual
              resultSet={result}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.currentPage}
              config={this.config}
              onChange={this.handleDataTableChange}
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={this.handlePageChange}
            />
          </Loadable>
        </Paper>
      </div>
    );
  }
}

export default DataTableView;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/list/data-table/view.jsx